/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_SubtitleInputs */

const en_svr_subtitle = /** @type {(inputs: Svr_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please provide additional details in the sections below.`)
};

const ja_svr_subtitle = /** @type {(inputs: Svr_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下のセクションに詳細を入力してください。`)
};

const fr_svr_subtitle = /** @type {(inputs: Svr_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez fournir des détails supplémentaires dans les sections ci-dessous.`)
};

const de_svr_subtitle = /** @type {(inputs: Svr_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie in den folgenden Abschnitten zusätzliche Details an.`)
};

/**
* | output |
* | --- |
* | "Please provide additional details in the sections below." |
*
* @param {Svr_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_subtitle = /** @type {((inputs?: Svr_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_subtitle(inputs)
	if (locale === "ja") return ja_svr_subtitle(inputs)
	if (locale === "fr") return fr_svr_subtitle(inputs)
	return de_svr_subtitle(inputs)
});